import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';
import { IQrCodePairResponse } from '../../../entity/interface/iQrCodes';

export interface IQrCodePairingUseCase {
    execute(bucketId: string): Promise<IQrCodePairResponse>;
}

export class QrCodePairingUseCase implements IQrCodePairingUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(bucketId: string): Promise<IQrCodePairResponse> {
        return await this.userRepo.qrCodePairing(bucketId);
    }
}
